export default "__VITE_ASSET__DOJjBCBz__"